import {
    MeasuredEmissionSourceByRegion,
    NotMeasuredEmissionSourceByRegion,
} from "../../api/models/Dashboard";
import { ragToRgb } from "../../constants";
import Card from "../Card";
import RegionalMap from "./RegionalMap";
import GridTable from "./GridTable";

export type ByRegionNonMeasuredCertaintyProps = {
    notMeasuredEmissionsSourcesByRegion: NotMeasuredEmissionSourceByRegion[];
    measuredEmissionsSourcesByRegion: MeasuredEmissionSourceByRegion[];
};

const ByRegionNonMeasuredCertainty = ({
    notMeasuredEmissionsSourcesByRegion,
    measuredEmissionsSourcesByRegion,
}: ByRegionNonMeasuredCertaintyProps) => {
    const data = notMeasuredEmissionsSourcesByRegion.map((_) => ({
        id: _.regionId,
        name: _.regionName,
        omittedEmissionsSourcesCount: _.omittedEmissionsSourcesCount,
        estimatedEmissionsSourcesCount: _.estimatedEmissionsSourcesCount,
    }));

    // TODO: below used measuredEmissionsSourcesByRegion data to populate regional map for now
    // this will be replaced in the future and this prop can be removed from this component entirely
    const mockRegionMapdata = measuredEmissionsSourcesByRegion.map((_) => ({
        id: _.regionId,
        name: _.regionName,
        redCount:
            _.missingEmissionsFactorCount +
            _.poorConfidenceCurrentEmissionsFactorsDataSourceCount,
        amberCount: _.fairConfidenceCurrentEmissionsFactorsDataSourceCount,
        greenCount: _.highConfidenceCurrentEmissionsFactorsDataSourceCount,
        color:
            _.missingEmissionsFactorCount +
                _.poorConfidenceCurrentEmissionsFactorsDataSourceCount >
            0
                ? ragToRgb.red
                : _.fairConfidenceCurrentEmissionsFactorsDataSourceCount > 0
                ? ragToRgb.amber
                : ragToRgb.green,
    }));

    return (
        <div className="flex lg:space-x-6 items-center">
            <Card className="hidden lg:block bg-white border-surface-light-5 border-2 shrink-0 w-[350px] p-2">
                <RegionalMap regionColors={mockRegionMapdata} />
            </Card>
            <GridTable
                gridTemplateColumns="1fr 1fr 1fr"
                data={data}
                headings={[
                    { label: "Region" },
                    { label: "Omitted sources" },
                    { label: "Estimated sources" },
                ]}
                renderRow={(rowData) => (
                    <>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.name}
                        </div>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.omittedEmissionsSourcesCount}
                        </div>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.estimatedEmissionsSourcesCount}
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default ByRegionNonMeasuredCertainty;
